import { Provider } from "react-redux";
import Header from "./components/Header";
import Section from "./components/Section";
import store from "./redux/store";

function App() {
  return (
    <>
      <Provider store={store}>
        <Header />
        <Section />
      </Provider>
    </>
  );
}

export default App;
